var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4279 43.4799L24 34L33 24L59.4142 50.4142C59.7893 50.7893 60 51.298 60 51.8284V58C60 59.1046 59.1046 60 58 60H51.8284C51.298 60 50.7893 59.7893 50.4142 59.4142L46.5858 55.5858C46.2107 55.2107 46 54.702 46 54.1716V53.5C46 52.6716 45.3284 52 44.5 52C43.6716 52 43 51.3284 43 50.5C43 49.6716 42.3284 49 41.5 49H40.8284C40.298 49 39.7893 48.7893 39.4142 48.4142L38.5858 47.5858C38.2107 47.2107 38 46.702 38 46.1716V46C38 44.8954 37.1046 44 36 44H35.7732C35.2757 44 34.796 43.8146 34.4279 43.4799Z",
    fill: "url(#paint0_linear_195_54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 23C42 33.4934 33.4934 42 23 42C12.5066 42 4 33.4934 4 23C4 12.5066 12.5066 4 23 4C33.4934 4 42 12.5066 42 23ZM17 21C19.2091 21 21 19.2091 21 17C21 14.7909 19.2091 13 17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21Z",
    fill: "url(#paint1_linear_195_54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3229 33.6771C23.8924 33.2466 23.8924 32.5486 24.3229 32.1181L32.1181 24.3229C32.5486 23.8924 33.2466 23.8924 33.6771 24.3229C34.1076 24.7534 34.1076 25.4514 33.6771 25.8819L25.8819 33.6771C25.4514 34.1076 24.7534 34.1076 24.3229 33.6771Z",
    fill: "url(#paint2_linear_195_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_54",
    x1: 45,
    y1: 37,
    x2: 31.5,
    y2: 50.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.284815,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744047,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_195_54",
    x1: 42,
    y1: 42,
    x2: 4,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.151316,
    stopColor: "#2E2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566C80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_195_54",
    x1: 30.1578,
    y1: 29.6066,
    x2: 28.5042,
    y2: 27.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.252542,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9AA99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.fe4b7d4efeeb99541d5a8c20031f31cb.svg";
export { ForwardRef as ReactComponent };